import { render, staticRenderFns } from "./NavToScroll.vue?vue&type=template&id=5f1555ec"
import script from "./NavToScroll.vue?vue&type=script&lang=js"
export * from "./NavToScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports